import { Info } from "lucide-react";
import { memo } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const InfoTooltip = ({ content }: { content: string }) => {
  return (
    <Popover>
      <PopoverTrigger>
        <Info className="text-muted-foreground mb-0.5 inline-flex h-4 w-4 cursor-pointer hover:text-gray-900" />
      </PopoverTrigger>
      <PopoverContent
        side="top"
        className="w-80 rounded-md border border-gray-200 bg-white px-3 py-2.5 text-sm leading-none text-gray-900 shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px]"
      >
        <p className="text-sm">{content}</p>
      </PopoverContent>
    </Popover>
  );
};

export default memo(InfoTooltip);
